import { Inject, Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { Environment } from '../../../app/types/environment.interface';
import { AddHeadersRequestPolicy } from '../../addresses-store/util';
import { ENVIRONMENT } from '../../core';
import { Order, OrderAPI, OrderAPIOptionalParams } from '../client/src';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  protected readonly baseApi: OrderAPI;

  constructor(@Inject(ENVIRONMENT) private env: Environment) {
    const clientParams: OrderAPIOptionalParams = {
      endpoint: `${env.nxApi.base}/${env.nxApi.fragment.order}`,
      additionalPolicies: [
        { policy: new AddHeadersRequestPolicy(), position: 'perCall' },
      ],
    };

    this.baseApi = new OrderAPI(clientParams);
  }

  public loadOrder(orderNumber: string, token: string): Observable<Order> {
    return from(this.baseApi.getOrderByOrderNumber(token, orderNumber));
  }
}
